import React, { Component } from 'react';
import Facet from './Facet';

class FacetGroup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false
		};
	}

	setActive() {
		if (this.state.active === false) {
			this.setState({ active: true });
		} else {
			this.setState({ active: false });
		}
	}

	render() {
		const FacetGroup = this.props.facetGroup;
		const facets = FacetGroup.items.map(
			(facet,index) => <Facet
				key={ index }
				facet={ facet }
				groupName={FacetGroup.name}
				groupValue={ FacetGroup.value }
			/>
		);

		return (
			<div className="option-section">
				<h3
					className={ `title ${this.state.active ? 'open' : ''}` }
					onClick={ () => this.setActive() }
				>
					{ FacetGroup.name }
				</h3>
				<ul className={ `facet-options ${this.state.active ? 'open' : ''}` }>
					{ facets }
				</ul>
			</div>
		);
	}
};

export default FacetGroup;


// WEBPACK FOOTER //
// ./src/pages/productSearch/FacetGroup.js